const ANALYTICS_ENDPOINT =
  import.meta.env.VITE_ANALYTICS_ENDPOINT ?? 'https://taxes.ahmed.wtf/api/track';
const APP_KEY = import.meta.env.VITE_ANALYTICS_APP_KEY ?? 'bpl_web_analytics_2026_a4c7f9d2e8b1';
const SESSION_KEY = 'bpl_growth_session';

type EventProperties = Record<string, string | number | boolean | null | undefined>;

function sessionId() {
  let value = sessionStorage.getItem(SESSION_KEY);
  if (!value) {
    value = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, value);
  }
  return value;
}

function safeReferrer() {
  if (!document.referrer) return undefined;
  try {
    return new URL(document.referrer).origin;
  } catch {
    return undefined;
  }
}

function attribution() {
  const current = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign'] as const;
  const values: EventProperties = {};
  for (const key of keys) {
    const incoming = current.get(key)?.slice(0, 64);
    if (incoming) sessionStorage.setItem(`bpl_${key}`, incoming);
    const stored = sessionStorage.getItem(`bpl_${key}`);
    if (stored) values[key] = stored;
  }
  return values;
}

export function trackEvent(event: string, properties: EventProperties = {}) {
  if (navigator.doNotTrack === '1') return;
  const cleanProperties = Object.fromEntries(
    Object.entries({ ...attribution(), ...properties })
      .filter(([, value]) => value !== undefined && value !== null)
      .slice(0, 8)
      .map(([key, value]) => [key.slice(0, 32), String(value).slice(0, 64)]),
  );
  const body = JSON.stringify({
    app_key: APP_KEY,
    event,
    properties: cleanProperties,
    session_id: sessionId(),
    platform: 'web',
    app_version: 'web-1',
    url: `${window.location.origin}${window.location.pathname}`,
    referrer: safeReferrer(),
  });
  void fetch(ANALYTICS_ENDPOINT, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
    keepalive: true,
    credentials: 'omit',
  }).catch(() => undefined);
}

const trackedMarketingPages = new Set<string>();
const trackedOnce = new Set<string>();

export function trackMarketingPage(pathname: string) {
  if (trackedMarketingPages.has(pathname)) return;
  trackedMarketingPages.add(pathname);
  trackEvent('landing_viewed', { page: pathname });
}

export function trackEventOnce(key: string, event: string, properties: EventProperties = {}) {
  if (trackedOnce.has(key)) return;
  trackedOnce.add(key);
  trackEvent(event, properties);
}
